import { useState } from "react"
import { useTranslate } from "ra-core"
import { AppBar, Box, Tabs } from "@mui/material"
import { TabWithIcon } from "components/ui/layouts"
import { ScreenEmpty } from "components/ui/screen"
import CompanyList from "./list.standart"
import CompanyTreeList from "./list.tree"

const TabList = ({onSelectTab}: {onSelectTab(id: number): void}) => {
  const translate = useTranslate()
  const [activeTab, setActiveTab] = useState<number>(0) 

  const selectTab = (id: number) => {
    setActiveTab(id)
    onSelectTab(id)
  }

  return (
      <Box display="flex" flexDirection="column" width="100%">
         <AppBar position="static" color="default">
                <Tabs
                    value={activeTab}
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <TabWithIcon label={translate("internal.list")} onClick={() => selectTab(0)} />
                    <TabWithIcon label={translate("internal.tree")} onClick={() => selectTab(1)} /*onClick={handleCombinedTabClick}  onClick={() => navigate(`/${tab?.resource}/${recordId}/${tab?.name}`)} icon={} *//>
                </Tabs>
            </AppBar>
      </Box>
  )
}

function CompanyTabList(props: {group: string, kind: string}): JSX.Element  {
    const [activeTab, setActiveTab] = useState<number>(0)
    return (
        <>        
            <TabList onSelectTab={(tabid) => setActiveTab(tabid)} />
            <ScreenEmpty enabled={activeTab === 0}>   <CompanyList /> </ScreenEmpty>
            <ScreenEmpty enabled={activeTab === 1}>   <CompanyTreeList /> </ScreenEmpty>
        </>
    )
}
export default CompanyTabList